export default __webpack_public_path__ + "static/media/sacaa_logo.ca172050.jpg";